import { UseFormReturn } from "react-hook-form";
import { Button, Card, Table } from "react-bootstrap";
import { bfKeyForHelp, numFrmt0Dec } from "../../../modules/common";
import { IKontrollResultRow } from "../../../types/BFL/Funktionskontroll";
import { BFLType } from "../../../types/DBTables";
import { FunktionskontrollEntry } from "../../../types/globalData";
import { useGlobalData } from "../../GlobalDataProvider";

interface IProps {
  bfName: string;
  funktionsKontroller: IKontrollResultRow[];
  formHook: UseFormReturn;
}

interface IPropsSub {
  bfName: string;
  funktionsKontroller: IKontrollResultRow[];
  formHook: UseFormReturn;
  showkwhs: boolean;
}

const FunktionskontrollerMedEllerUtanKW = ({ bfName, funktionsKontroller, formHook, showkwhs }: IPropsSub) => {
  const globalData = useGlobalData();
  if (!funktionsKontroller || !funktionsKontroller.length || !globalData) return <></>;
  //const showkwhs = funktionsKontroller.find((r) => r.kWhs || r.energiSlag) ? true : false;
  const showÅtgärdad = funktionsKontroller.find((r) => r.VisaÅtgärdad) ? true : false;
  const showMerInfo = funktionsKontroller.find((r) => r.VisaMerInfo) ? true : false;

  const tblName = showkwhs ? "funktionsKontrollerWValues" : "funktionsKontrollerWOValues";
  //const tblName = "funktionsKontroller";

  return (
    <>
      <Card className="mb-3">
        <Card.Header>{showkwhs ? "Funktionskontroller" : "Funktionsmeddelanden"}</Card.Header>
        <Table bordered hover>
          <thead>
            <tr>
              {globalData.isDebug && <th>Id</th>}
              {showkwhs ? (
                <>
                  <th style={{ width: 150 }}>Energislag</th>
                  <th style={{ width: 150, textAlign: "left" }}>kWh/år</th>
                </>
              ) : (
                <></>
              )}

              <th>Meddelande funktionskontroll </th>

              {showMerInfo && <th style={{ width: 50 }}>Visa</th>}
              {showÅtgärdad && <th style={{ width: 50 }}>Åtgärdad</th>}
            </tr>
          </thead>
          <tbody>
            {funktionsKontroller.map((fk: IKontrollResultRow, index) => (
              <tr key={(fk.OverrideBFName || "") + fk.index + (fk.variant || "")}>
                {globalData.isDebug && <td>{(fk.OverrideBFName || "") + fk.index + (fk.variant || "")}</td>}
                {showkwhs && (
                  <>
                    <td>
                      {fk.kWhs ? fk.energiSlag : ""}
                      <input type="hidden" defaultValue={fk.energiSlag} {...formHook.register(tblName + "." + index + ".energiSlag")} />
                    </td>
                    <td style={{ textAlign: "right", paddingRight: 20 }}>
                      {fk.kWhs ? numFrmt0Dec.format(Number(fk.kWhs)) : ""}
                      <input type="hidden" {...formHook.register(tblName + "." + index + ".kWhs", { value: fk.kWhs })} />
                    </td>
                  </>
                )}

                <td>
                  {fk.message}
                  <input type="hidden" {...formHook.register(tblName + "." + index + ".message", { value: fk.message })} />
                </td>

                {showMerInfo && (
                  <td>
                    {fk.VisaMerInfo && (
                      <Button
                        style={{ fontSize: "0.8em", minWidth: 70, padding: "5px 0px" }}
                        onClick={() => PubSub.publish("ShowHelp", bfKeyForHelp[(fk.OverrideBFName || bfName) as BFLType] + "_FKText" + fk.index + (fk.variant || ""))}
                      >
                        Mer info
                      </Button>
                    )}
                  </td>
                )}
                {showÅtgärdad && (
                  <td style={{ textAlign: "center" }}>{fk.VisaÅtgärdad && <input type="checkbox" {...formHook.register(tblName + "." + index + ".Åtgärdad")} className="form-check-input" />}</td>
                )}
                {/* <td>
                  <Button
                    style={{ fontSize: "0.8em", minWidth: 70, padding: "5px 0px" }}
                    onClick={() => PubSub.publish("ShowHelp", bfKeyForHelp[(fk.OverrideBFName || bfName) as BFLType] + "_FKText" + fk.index + (fk.variant || ""))}
                  >
                    Mer info
                  </Button>
                  {!showkwhs ? (
                    <>
                      <input type="hidden" {...formHook.register("funktionsKontroller." + index + ".Åtgärdad", { value: false })} />
                    </>
                  ) : (
                    <></>
                  )}
                </td> */}
                {/* {showÅtgärdad ? (
                  <td style={{ textAlign: "center" }}>
                    <input type="checkbox" {...formHook.register("funktionsKontroller." + index + ".Åtgärdad")} className="form-check-input" />
                  </td>
                ) : (
                  <></>
                )} */}
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
};

const Funktionskontroller = ({ bfName, funktionsKontroller, formHook }: IProps) => {
  const globalData = useGlobalData();
  if (!funktionsKontroller || !funktionsKontroller.length || !globalData) return <></>;

  const funktionsKontrollerWValues = funktionsKontroller.filter((fk) => fk.kWhs || fk.energiSlag);
  const funktionsKontrollerWOValues = funktionsKontroller.filter((fk) => !fk.kWhs && !fk.energiSlag);

  return (
    <>
      {funktionsKontrollerWValues.length > 0 && <FunktionskontrollerMedEllerUtanKW bfName={bfName} funktionsKontroller={funktionsKontrollerWValues} formHook={formHook} showkwhs={true} />}
      {funktionsKontrollerWOValues.length > 0 && <FunktionskontrollerMedEllerUtanKW bfName={bfName} funktionsKontroller={funktionsKontrollerWOValues} formHook={formHook} showkwhs={false} />}
      {/* <Card className="mb-3">
        <Card.Header>Funktionskontroller</Card.Header>
        <Table bordered hover>
          <thead>
            <tr>
              {globalData.isDebug && <th>Id</th>}
              {showkwhs ? (
                <>
                  <th style={{ width: 150 }}>Energislag</th>
                  <th style={{ width: 150, textAlign: "left" }}>kWh/år</th>
                </>
              ) : (
                <></>
              )}

              <th>Meddelande funktionskontroll </th>

              {showMerInfo && <th style={{ width: 50 }}>Visa</th>}
              {showÅtgärdad && <th style={{ width: 50 }}>Åtgärdad</th>}
            </tr>
          </thead>
          <tbody>
            {funktionsKontroller.map((fk: IKontrollResultRow, index) => (
              <tr key={(fk.OverrideBFName || "") + fk.index + (fk.variant || "")}>
                {globalData.isDebug && <td>{(fk.OverrideBFName || "") + fk.index + (fk.variant || "")}</td>}
                {showkwhs && (
                  <>
                    <td>
                      {fk.kWhs ? fk.energiSlag : ""}
                      <input type="hidden" defaultValue={fk.energiSlag} {...formHook.register("funktionsKontroller." + index + ".energiSlag")} />
                    </td>
                    <td style={{ textAlign: "right", paddingRight: 20 }}>
                      {fk.kWhs ? numFrmt0Dec.format(Number(fk.kWhs)) : ""}
                      <input type="hidden" {...formHook.register("funktionsKontroller." + index + ".kWhs", { value: fk.kWhs })} />
                    </td>
                  </>
                )}

                <td>
                  {fk.message}
                  <input type="hidden" {...formHook.register("funktionsKontroller." + index + ".message", { value: fk.message })} />
                </td>
                <td>
                  <Button
                    style={{ fontSize: "0.8em", minWidth: 70, padding: "5px 0px" }}
                    onClick={() => PubSub.publish("ShowHelp", bfKeyForHelp[(fk.OverrideBFName || bfName) as BFLType] + "_FKText" + fk.index + (fk.variant || ""))}
                  >
                    Mer info
                  </Button>
                  {!showkwhs ? (
                    <>
                      <input type="hidden" {...formHook.register("funktionsKontroller." + index + ".Åtgärdad", { value: false })} />
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                {showkwhs ? (
                  <td style={{ textAlign: "center" }}>
                    <input type="checkbox" {...formHook.register("funktionsKontroller." + index + ".Åtgärdad")} className="form-check-input" />
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </Card> */}
    </>
  );
};

export default Funktionskontroller;
